import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import * as _ from 'lodash';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { SharedService } from '../../../shared-components/shared.service';
import { CustomizationFrameworkService } from '../../../shared-modules/customization-framework/customization-framework.service';
import { AddEditDynamicDataDefinitionComponent } from '../data-definition-dynamic/add-edit-dynamic-data-definition/add-edit-dynamic-data-definition.component';
import { DataDefinitionDynamicColumn, DataDefinitionList } from '../data-definition.model';
import { DataDefinitionService } from '../data-definition.service';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'data-definition-dynamic',
  templateUrl: './data-definition-dynamic.component.html',
  styleUrls: ['./data-definition-dynamic.component.css']
})
export class DataDefinitionDynamicComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  dataDefList: DataDefinitionList;
  dataDef: any = [];
  dataDefBindings: any;
  subscriptions: Subscription[] = [];
  dataSource: TylerMatTableDataSource = new TylerMatTableDataSource(this.dataDef);
  displayedColumns: string[] = [];
  cols: string[] = [];
  columns: DataDefinitionDynamicColumn[] = [];
  columnMappings: any;

  @Input() DataDefList: DataDefinitionList;
  @Input() set addClick(trigger: EventEmitter<any>) {
    this.subscriptions.push(trigger.subscribe(o => {
      this.addDataDef();
    }));
  }

  @Input() set saveSequenceClick(trigger: EventEmitter<any>) {
    this.subscriptions.push(trigger.subscribe(o => {
      this.dataDef.forEach(row => {
        const tableName = this.dataDefList.TableName;
        const keyColName = this.columns[0].ColumnName;
        const keyColValue = row[this.columns[0].ColumnName];

        this.subscriptions.push(this.dataDefinitionService.saveDynamicDataDefinition(tableName, keyColName, keyColValue, row).subscribe(result => {
          // clear in-memory value to force data def dropdown to get new values
          this.customizationFrameworkService.dataDefinitionListValues[this.dataDefList.Enum] = null;
          if (this.customizationFrameworkService.dataDefinitionLists.find(d => d.Enum == this.dataDefList.Enum)) {
            this.customizationFrameworkService.dataDefinitionLists.find(d => d.Enum == this.dataDefList.Enum).DataDefinitions = null;
          }

        }));
      });

      setTimeout(() => {
        this.sharedService.showGoodSnackbar();
      }, 300);
    }));
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private dialog: MatDialog,
    private sharedService: SharedService,
    private dataDefinitionService: DataDefinitionService,
    private customizationFrameworkService: CustomizationFrameworkService
  ) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.DataDefList && this.DataDefList.Id > 0) {
      this.dataDefList = this.DataDefList;
      this.getDataDefinition();
    }
  }

  ngAfterViewInit() {
    if (this.dataSource && this.dataSource.data != null) {
      this.dataSource.sort = this.sort;
    }
  }

  ngOnDestroy() { }

  getColumnSettings() {
    this.columns = [];
    const columnSetting = JSON.parse(this.dataDefList.MetaData);
    const cols = columnSetting.map(c => c.ColumnName);
    cols.forEach((element, index) => {
      const columnName = columnSetting[index].ColumnName;
      const displayName = columnSetting[index].DisplayName;
      const dataType = columnSetting[index].DataType;
      const controlType = columnSetting[index].ControlType;
      const required = columnSetting[index].Required;
      const editable = columnSetting[index].Editable;
      const minLength = columnSetting[index].MinLength;
      const maxLength = columnSetting[index].MaxLength;
      const displayOnGrid = columnSetting[index].DisplayOnGrid;
      const displayOnForm = columnSetting[index].DisplayOnForm;
      const gridSequence = columnSetting[index].GridSequence;
      const formSequence = columnSetting[index].FormSequence;
      const cell = columnSetting[index].ColumnName;

      this.columns.push(new DataDefinitionDynamicColumn(columnName, displayName, dataType, controlType, required,
        editable, minLength, maxLength, displayOnGrid, displayOnForm, gridSequence, formSequence, cell));
    });

    // display columns in the order defined in MetaData
    this.columns.sort((a, b) => a.GridSequence - b.GridSequence);

    // display columns that should be visible on grid
    this.displayedColumns = this.columns.filter(c => c.DisplayOnGrid).map(c => c.ColumnName);
    this.displayedColumns.push('Actions');

    if (this.dataDefList.IsSortable) {
      this.displayedColumns.unshift('drag-handle');
    }
  }

  getDataDefinition() {
    this.dataDefinitionService.getDynamicDataDefinition(this.dataDefList.Id, 0).subscribe(res => {
      if (res) {
        const data = JSON.parse(res.LookupValuesJSON);
        if (data != null) {
          // if lockup table has atleast one row
          this.dataDef = data.LookupValues;
          this.dataDefBindings = data.LookupBindings;

          this.getColumnSettings();

          if (!(this.dataDef instanceof Array)) {
            // if not an array, convert object into an array
            this.dataDef = [this.dataDef];
          }

          this.dataDef.forEach(element => {
            this.columns.filter(c => c.DataType === 'boolean').map(c => c.ColumnName).forEach(x => {
              {
                element[x] = (element[x] === ('0' || 'false') ? false : true);
              }
            });
          });

          // assign datasource to table
          this.dataSource.data = this.dataDef;
        } else {
          // if lookup table is empty
          this.getColumnSettings();
          // assign datasource to table
          this.dataSource.data = [];
        }
      }
    });
  }

  addDataDef() {
    const newDataDef: any = {};
    this.columns.forEach(x => {
      newDataDef[x.ColumnName] = null;
    });

    const dialogRef = this.dialog.open(AddEditDynamicDataDefinitionComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });
    dialogRef.componentInstance.dataDefList = _.cloneDeep(this.dataDefList);
    dialogRef.componentInstance.dataDef = Object.assign({}, newDataDef);
    dialogRef.componentInstance.allDataDef = _.cloneDeep(this.dataDef);
    dialogRef.componentInstance.dataDefBindings = _.cloneDeep(this.dataDefBindings);
    dialogRef.componentInstance.fields = this.columns;

    this.subscriptions.push(dialogRef.afterClosed().subscribe(action => {
      if (action == 'save') {
        this.saveDynamicDataDefinition(dialogRef.componentInstance.dataDef);
      }
    }));
  }

  editClick(dataDef: any) {
    const dialogRef = this.dialog.open(AddEditDynamicDataDefinitionComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });
    dialogRef.componentInstance.dataDefList = _.cloneDeep(this.dataDefList);
    dialogRef.componentInstance.dataDef = _.cloneDeep(dataDef);
    dialogRef.componentInstance.allDataDef = _.cloneDeep(this.dataDef);
    dialogRef.componentInstance.dataDefBindings = _.cloneDeep(this.dataDefBindings);
    dialogRef.componentInstance.fields = this.columns;

    this.subscriptions.push(dialogRef.afterClosed().subscribe(action => {
      if (action == 'save') {
        this.saveDynamicDataDefinition(dialogRef.componentInstance.dataDef);
      }
    }));
  }

  deleteClick(dataDef: any) {
    const tableName = this.dataDefList.TableName;
    const colIdName = this.columns[0].ColumnName;
    const colIdValue = dataDef[this.columns[0].ColumnName];
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });

    this.dataDefinitionService.dataDefCodeInUse(this.dataDefList.Enum, colIdValue).subscribe(res => {
      if (res && res == true) {
        deleteConfirmDialog.componentInstance.headerLabel = ' DELETION NOT ALLOWED';
        deleteConfirmDialog.componentInstance.warning = true;
        deleteConfirmDialog.componentInstance.informational = true;
        deleteConfirmDialog.componentInstance.confirmMessage = 'The record cannot be deleted because it is in use.';
        deleteConfirmDialog.componentInstance.headerCenterAlign = true;
      } else {
        deleteConfirmDialog.componentInstance.headerLabel = 'Delete Code';
        deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete the record?';
        deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
        deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
          if (deleteObject) {
            this.dataDefinitionService.deleteDynamicDataDefinition(tableName, colIdName, colIdValue).subscribe(r => {
              if (r === 'Success') {
                this.sharedService.showGoodSnackbar();
                this.getDataDefinition();
              }
            });
          }
        });
      }
    });
  }

  saveDynamicDataDefinition(dataDef: any) {
    const tableName = this.dataDefList.TableName;
    const keyColName = this.columns[0].ColumnName;
    const keyColValue = dataDef[this.columns[0].ColumnName];

    this.subscriptions.push(this.dataDefinitionService.saveDynamicDataDefinition(tableName, keyColName, keyColValue, dataDef).subscribe(result => {
      if (result) {
        // clear in-memory value to force data def dropdown to get new values
        this.customizationFrameworkService.dataDefinitionListValues[this.dataDefList.Enum] = null;
        if (this.customizationFrameworkService.dataDefinitionLists.find(o => o.Enum == this.dataDefList.Enum)) {
          this.customizationFrameworkService.dataDefinitionLists.find(o => o.Enum == this.dataDefList.Enum).DataDefinitions = null;
        }
        this.sharedService.showGoodSnackbar();
        this.getDataDefinition();
      }
      else {
        this.sharedService.showBadSnackbar();
      }
    }));
  }

  clearFilter() {
    this.dataSource.removeAllFilters();
  }

  rowDrop(event: CdkDragDrop<any, any>) {
    // PRE: one of the row is dragged and dropped within the table
    // POST: rearranges the order of the sort fields and sets the query to changed
    // NOTE: we have to manually obtain the previous index because the event.previousIndex is wrong

    const field = event.item.data;
    const previousIndex = this.dataDef.indexOf(field);
    moveItemInArray(this.dataDef, previousIndex, event.currentIndex);
    this.dataDef.forEach((ec, index) => {
      ec.intSequence = index;
    });
    this.dataSource.data = this.dataDef;
  }

  getFilterType(dataType: string): 'string' | 'number' | 'date' | 'boolean' | 'enumeration' | 'nullable boolean' {
    switch (dataType) {
      case 'float':
      case 'number': return 'number';
      case 'date': return 'date';
      case 'boolean': return 'boolean';
      case 'enumeration': return 'enumeration';
      case 'nullable boolean': return 'nullable boolean';
      default: return 'string';
    }
  }
}
